/**
 * Centralized frontend brand config — mirrors backend brand_config.py.
 *
 * GOOGLE ADS / COMPLIANCE PLACEHOLDERS
 * ====================================
 * The four `legal.*` fields below MUST be updated to real, verifiable values
 * before submitting the site to Google Ads. Until then they render as a
 * "pending registration" notice so we don't deceive customers or Google.
 *
 * When you have your LLC / address / phone ready:
 *   1. Edit only this file (4 lines)
 *   2. Redeploy
 *   3. Submit to Google Ads
 *
 * Search the codebase for "PLACEHOLDER:" to confirm there are no other
 * compliance fields to update.
 */
export const BRAND = {
  name: "GC SPARK",
  legalName: "GC SPARK",
  domain: "gcspark.com",
  supportEmail: "support@gcspark.com",
  businessEmail: "desk@gcspark.com",
  assistantName: "EVA",
  managerName: "Oliver Grant",
  managerTitle: "Operations Manager",
  logoText: "GC SPARK",
  tagline: "Gift card payouts, simplified",
  description:
    "GC SPARK is a straightforward way to convert unused gift cards into cash via PayPal, Cash App, Zelle, or Chime.",
  payoutMethods: ["PayPal", "Cash App", "Zelle", "Chime"],

  // ---- Ownership disclosure ----
  ownerName: "Tayyaba Khalid",
  ownerCountry: "Pakistan",

  // ---- Compliance / Trust signals ----
  legal: {
    entityName: "GC SPARK",
    addressCountry: "PK",
    yearFounded: 2025,
  },

  // Operating region
  operatingRegion: "Online (worldwide submissions accepted)",
  minimumAgeYears: 18,

  // Social profiles for Organization schema's `sameAs`. Leave empty strings
  // (or add real URLs) — empty entries are filtered out at render time.
  social: {
    twitter: "",
    facebook: "",
    instagram: "",
    linkedin: "",
  },
};
